export default __webpack_public_path__ + "static/media/misc-pantry1-1440w.1293b66f.png";